/* import __COLOCATED_TEMPLATE__ from './heat-startlist-interface.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { TrackedArray } from 'tracked-built-ins';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export default class HeatStartlistComponent extends Component
{
	@service store;
	@service csv;
	@service sprintTools;
	
	@tracked sourceEvent;
	@tracked destinationClassGroup;
	
	@tracked startTime;
	
	@tracked bibForNewEntry;
	@tracked newBibForNewEntry;

	@tracked heatAssignments = new TrackedArray();

	heatStartOrderCounter = 0;
	
	@action
	async sourceEventChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.sourceEvent = null;
			this.destinationClassGroup = null;
		}
		else
		{
			var event = await this.store.findRecord('Event', browserEvent.target.value);
			this.sourceEvent = event;
			this.destinationClassGroup = null;
		}
	}
	
	@action
	async destinationClassGroupChanged(browserEvent)
	{
		if(browserEvent.target.value == '-')
		{
			this.destinationClassGroup = null;
		}
		else
		{
			var classGroup = await this.store.findRecord('ClassGroup', browserEvent.target.value);
			this.startTime = dayjs(classGroup.startTime).format("HH:mm:ss");
			this.destinationClassGroup = classGroup;
		}
	}
	
	@action
	async newEntry(browserEvent)
	{
		browserEvent.preventDefault();

		if(this.sourceEvent == null)
		{
			return;
		}

		var entries = await this.sourceEvent.get('entries');
		var entry = entries.find(e => e.bib == this.bibForNewEntry);
		if (entry)
		{
			entry.set('newBib', this.newBibForNewEntry);
			entry.set('heatStartOrder', this.heatStartOrderCounter + 1);
			this.heatStartOrderCounter += 1;
			this.heatAssignments.push(entry);
		}
	}
	
	@action
	exportHeatStartListCSV()
	{
		// Check if assignments exist before exporting
		if (!this.heatAssignments || this.heatAssignments.length === 0) {
			return;
		}

		var data = [...this.sprintTools.getCSVHeaders()];

		for (const result of this.heatAssignments)
		{
			data.push(this.sprintTools.buildCSVRow(result, this.destinationClassGroup, this.startTime, result.newBib));
		}

		this.csv.export(data, {fileName:'heatStartlist.csv',withSeparator:false});
	}
	
	@action
	async createClasses()
	{
		var destinationClasses = await this.args.destinationEvent.get('classes');
		await this.sprintTools.createClassesForHeat(
			this.args.destinationEvent,
			destinationClasses,
			this.destinationClassGroup,
			this.heatAssignments
		);
	}
	
	@action
	async createEntries()
	{
		var destinationEntries = await this.args.destinationEvent.get('entries');
		var destinationClasses = await this.args.destinationEvent.get('classes');

		await this.sprintTools.createEntriesForHeat(
			this.args.destinationEvent,
			destinationEntries,
			destinationClasses,
			this.destinationClassGroup,
			this.heatAssignments,
			this.startTime,
			true // useNewBib
		);
	}
}